import axios from 'axios'
import { apiUrl } from '../config'
import authenticationStore from '../stores/authenticationStore'

export const InfoOptionRequest = {
  getInfoOption: params =>
    axios({
      method: 'get',
      url: `${apiUrl}/api/v1/info_option`,
      headers: {
        Authorization: `Bearer ${
          JSON.parse(authenticationStore.appToken).access_token
        }`,
        'Content-Type': 'application/json',
      },
      params,
    }),
}
